import { render } from "./CaseList.vue?vue&type=template&id=960d1efc"
import script from "./CaseList.vue?vue&type=script&lang=js"
export * from "./CaseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__